export const sortByName = (arr) =>
  [...arr].sort((a, b) => a.name.localeCompare(b.name));

export const sortByPosition = (arr) =>
  [...arr].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));

export const sortBySelected = (arr, selectedIds = []) =>
  [...arr].sort(
    (a, b) =>
      Number(selectedIds.includes(b.id)) - Number(selectedIds.includes(a.id))
  );
